import { createEntityAdapter } from '@reduxjs/toolkit';
import { RightRoleAPIResponse } from './right.model';
import { getLanguage } from '../../../i18n';

export const RolesAdapter = createEntityAdapter({
  selectId: (role: RightRoleAPIResponse) => role.id,
  sortComparer: (a, b) => getNameFromRole(a).localeCompare(getNameFromRole(b)),
});

export const getNameFromRole = (role: RightRoleAPIResponse): string => {
  const language = getLanguage();
  return role.internationalizedNames?.[language] || role.name || '';
};
